<template>
  <div class="container">
    <component :is="currentPage.component" />
  </div>
</template>

<script>
import ShippingOptions from './ShippingOptions.vue'
import ShippingFeatures from './ShippingFeatures.vue'
import RouteCharacteristics from './RouteCharacteristics.vue'
import ComponentSelection from './ComponentSelection.vue'
import ShippingLogistics from './ShippingLogistics.vue'
import ReceptionLogistics from './Import/ReceptionLogistics.vue'
import FinancialAdministrativeCosts from './FinancialAdministrativeCosts.vue'
import FinancialAdministrativeCostsImport from './Import/FinancialAdministrativeCostsImport.vue'
import InsuranceAndExtras from './InsuranceAndExtras.vue'
import InsuranceAndExtrasImport from './Import/InsuranceAndExtrasImport.vue'
import InlandTransportation from './InlandTransportation.vue'
import InlandTransportationImport from './Import/InlandTransportationImport.vue'
import AdministrationFees from './AdministrationFees.vue'
import ProceduresAndPermits from './ProceduresAndPermits.vue'
import CustomClearanceImport from './Import/CustomClearanceImport.vue'
import TaxesAndFees from './TaxesAndFees.vue'
import TerminalManagement from './TerminalManagement.vue'
import TerminalManagementImport from './Import/TerminalManagementImport.vue'
import InternationalTransport from './InternationalTransport.vue'
import Incoterm from './Incoterm/Incoterm'
import AirportManagement from './AirportManagement'
import AirportManagementImport from './Import/AirportManagementImport'

import Results from './Results.vue'

import { mapGetters } from 'vuex'

export default {

  name: 'WizardContent',
  components: {
    ShippingOptions,
    Incoterm,
    ShippingFeatures,
    RouteCharacteristics,
    ComponentSelection,
    ShippingLogistics,
    ReceptionLogistics,
    FinancialAdministrativeCosts,
    FinancialAdministrativeCostsImport,
    InsuranceAndExtras,
    InsuranceAndExtrasImport,
    InlandTransportation,
    InlandTransportationImport,
    AdministrationFees,
    ProceduresAndPermits,
    CustomClearanceImport,
    TaxesAndFees,
    TerminalManagement,
    TerminalManagementImport,
    AirportManagement,
    AirportManagementImport,
    InternationalTransport,
    Results
  },

  computed: {
    ...mapGetters([
      'currentPage'
    ])
  }

}
</script>
<style scoped>
  .container{
    margin: 10px;
    width: 100%;
  }
</style>
